// GET ALL TAXMASTER LIST
export const GET_ALL_TAXMASTER = "GET_ALL_TAXMASTER";
export const GET_ALL_TAXMASTER_SUCCESS = "GET_ALL_TAXMASTER_SUCCESS";
export const GET_ALL_TAXMASTER_FAIL = "GET_ALL_TAXMASTER_FAIL";

//GET ALL TAXMASTER WITH STATUS.
export const GET_ALL_TAXMASTER_WITH_STATUS = "GET_ALL_TAXMASTER_WITH_STATUS";
export const GET_ALL_TAXMASTER_WITH_STATUS_SUCCESS =
  "GET_ALL_TAXMASTER_WITH_STATUS";
export const GET_ALL_TAXMASTER_WITH_STATUS_FAIL =
  "GET_ALL_TAXMASTER_WITH_STATUS_FAIL";

// For Creating TAXMASTER
export const CREATE_TAXMASTER = "CREATE_TAXMASTER";
export const CREATE_TAXMASTER_SUCCESS = "CREATE_TAXMASTER_SUCCESS";
export const CREATE_TAXMASTER_FAIL = "CREATE_TAXMASTER_FAIL";

// For Updating TAXMASTER Data Status
export const UPDATE_TAXMASTER = "UPDATE_TAXMASTER";
export const UPDATE_TAXMASTER_SUCCESS = "UPDATE_TAXMASTER_SUCCESS";
export const UPDATE_TAXMASTER_FAIL = "UPDATE_TAXMASTER_FAIL";

// For Searching TAXMASTER
export const SEARCH_TAXMASTER = "SEARCH_TAXMASTER";
export const SEARCH_TAXMASTER_SUCCESS = "SEARCH_TAXMASTER_SUCCESS";
export const SEARCH_TAXMASTER_FAIL = "SEARCH_TAXMASTER_FAIL";

// For Getting TAXMASTER by TAXMASTERId
export const GET_TAXMASTER_BY_ID = "GET_TAXMASTER_BY_ID";
export const GET_TAXMASTER_BY_ID_SUCCESS = "GET_TAXMASTER_BY_ID_SUCCESS";
export const GET_TAXMASTER_BY_ID_FAIL = "GET_TAXMASTER_BY_ID_FAIL";

// Upload all documents
export const UPLOAD_ALL_DOCUMENTS_TAXMASTER = "UPLOAD_ALL_DOCUMENTS_TAXMASTER";
export const UPLOAD_ALL_DOCUMENTS_TAXMASTER_SUCCESS =
  "UPLOAD_ALL_DOCUMENTS_TAXMASTER_SUCCESS";
export const UPLOAD_ALL_DOCUMENTS_TAXMASTER_FAIL =
  "UPLOAD_ALL_DOCUMENTS_TAXMASTER_FAIL";

export const CREATE_EDIT_TAX_MASTER_API_STATUS =
  "CREATE_EDIT_TAX_MASTER_API_STATUS";

export const CREATE_TAX_MASTER_DISABLE = "CREATE_TAX_MASTER_DISABLE";
export const TAX_MASTER_LOADER = "TAX_MASTER_LOADER";
